import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import About from './containers/About/About';
import Celebrities from './containers/Celebrities/Celebrities';
import CollectionCover from './containers/CollectionCover/CollectionCover';
import CollectionDetails from './containers/CollectionDetails/CollectionDetails';
import Collections from './containers/Collections/Collections';
import Contact from './containers/Contact/Contact';
import Home from './containers/Home/Home';
import Press from './containers/Press/Press';
import Videos from './containers/Videos/Videos';

class App extends Component {
    render() {
        return (
            <Switch>
                <Route path="/" exact component={Home} />
                <Route path="/bio" component={About} />
                <Route path="/celebridades" component={Celebrities} />
                <Route path="/prensa" component={Press} />

                {/* COLLECTIONS */}
                <Route
                    exact
                    path="/colecciones/:cat"
                    component={CollectionCover}
                />
                <Route
                    exact
                    path="/colecciones/:cat/:subcat"
                    component={Collections}
                />
                <Route
                    exact
                    path="/colecciones/:cat/:subcat/:compoundId"
                    component={CollectionDetails}
                />
                <Route
                    exact
                    path="/colecciones/:cat/:subcat"
                    component={Collections}
                />
                <Route
                    exact
                    path="/colecciones/:cat/:subcat/:compoundId"
                    component={CollectionDetails}
                />

                <Route path="/contacto" component={Contact} />
                <Route path="/citas" component={Contact} />
                <Route path="/videos" exact component={Videos} />
                <Route path="/videos/novias" component={Videos} />
                <Redirect to="/" />
            </Switch>
        );
    }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js